import React, { useEffect, useState } from 'react'
import { QRCodeCanvas } from "qrcode.react";

import "./Results.css"
import { useParams } from 'react-router-dom';
import { getProjectById, getProjects } from './../../services';

export const Results = () => {
    const [currentProject, setProject] = useState(null)
    const [currentId, setId] = useState(1)
    const [projects, setProjects] = useState([]);
    const [showedProjects, setShowedProjects] = useState([]);
    const { eventId } = useParams()
    const currentURL = window.location.href;
    const [end, setEnd] = useState(false)
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        (async () => {
            const { data, error } = await getProjects(eventId)
            console.log(data, error);
            setProjects(data)
        })()
    }, [])

    useEffect(() => {
        (async () => {
            const { data, error } = await getProjectById(eventId, currentId)
            console.log(data, error);
            setProject(data)
            setLoading(true)

            if (showedProjects.length > projects.length) return
            setTimeout(() => {
                setShowedProjects(prev => [...prev, data])
                setLoading(false)
            }, 1000)
        })()
    }, [currentId])

    const toNext = () => {
        if (currentId >= projects.length) {
            setEnd(true)
            return
        }
        setId(currentId + 1)
    }


    return (
        <div className='voting'>
            <div className='qr' style={{ opacity: end ? 1 : 0, transition: ".3s", height: end ? "auto" : 0, flex: end ? 1 : 0 }}>
                <QRCodeCanvas value={currentURL} size={1000} style={{ width: "auto", height: "100%", padding: end ? "80px" : "0px" }} level="H" />
            </div>
            <div className='voting_block resulted'>
                {!loading ? <> {currentProject && <img src={`https://api.chill-with-tech.gitc.am/${currentProject?.image}`} alt="" />}
                    <div className='voting_info'>
                        {currentProject && <h3>{currentProject.name}</h3>}
                        {currentProject && <p>{currentProject.description}</p>}
                        {currentProject && <h2>{currentProject.rating}</h2>}
                        <button className='confirm' onClick={toNext}>Next</button>
                    </div></> : <div className="loading"><span></span></div>}
            </div>
            <div className='results'>
                <h2>Results</h2>
                <div className='results_rating'>
                    {showedProjects.length ?
                        showedProjects.sort((a, b) => b.rating - a.rating).slice(0, 10).map((pr, i) => {
                            return <div className="project" style={{ top: `calc(${i * 8}vh + 10px)` }} key={pr.id}> <span>{i + 1}. {pr.name}</span> <span>{pr.rating}</span></div>
                        })
                        : <></>}
                </div>
            </div>
            <div className='results mobile'>
                <h2>Results</h2>
                <div className='results_rating'>
                    {showedProjects.length ?
                        projects.sort((a, b) => b.rating - a.rating).map((pr, i) => {
                            return <div className="projectMobile" key={pr.id}> <span>{i + 1}. {pr.name}</span> <span>{pr.rating}</span></div>
                        })
                        : <></>}
                </div>
            </div>
        </div>
    )
}
